import { render, staticRenderFns } from "./confirmDate.vue?vue&type=template&id=70ffee83&scoped=true&"
import script from "./confirmDate.vue?vue&type=script&lang=js&"
export * from "./confirmDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ffee83",
  null
  
)

export default component.exports